/**
 * Gets a value from an object using a path.
 * @param {Object} obj - Object.
 * @param {string} path - Path (ej: 'user.profile.name').
 */
export const getNestedValue = (obj, path) => {
    if (!path) return undefined;
    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
};

/**
 * Assign a value to an object in a specific path.
 * If the intermediate properties do not exist, it creates them as objects.
 * @param {Object} obj - Object.
 * @param {string} path - Path (ej: 'user.profile.name').
 * @param {any} value - Value to assign.
 * @returns {Object} The modified object.
 */
export const setNestedValue = (obj, path, value) => {
    if (!path) return obj;

    const keys = path.split('.');
    const lastKey = keys.pop();

    const lastObj = keys.reduce((acc, part) => {
        if (!acc[part]) acc[part] = {};
        return acc[part];
    }, obj);

    lastObj[lastKey] = value;

    return obj;
};